import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { Content } from '../../models/content';
import { ActivatedRoute, Router } from '@angular/router';
import { AppLauncher, OpenURLOptions } from '@capacitor/app-launcher';
import { IonModal, Platform } from '@ionic/angular';
import { ContentService } from '../../services/content.service';
// import { TextToSpeechAdvanced } from '@awesome-cordova-plugins/text-to-speech-advanced/ngx';
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { Browser } from '@capacitor/browser';
import { Schedule, Place } from '../../models/contentResults';
import { Share } from '@capacitor/share';
import { AppConfig } from '../../services/app-config.service';

import moment from 'moment'
import { AnalyticsService } from '../../services/analytics.service';
import { LoadDataService } from 'src/app/services/load-data.service';
moment.locale('es');

@Component({
  selector: 'app-content',
  templateUrl: './content.page.html',
  styleUrls: ['./content.page.scss'],
})
export class ContentPage implements OnInit {

  @ViewChild('modal') modal: IonModal;
  @ViewChild('modal2') modal2: IonModal;
  @ViewChild('modal3') modal3: IonModal;
  @ViewChild('modal4') modal4: IonModal;
  @ViewChild('modal5') modal5: IonModal;
  @ViewChild('modalShare') modalShare: IonModal;  

  content: Content;
  loading = true;

  playing = false;
  isStopped = false;

  showBtnApp = false;
  showIos = false;

  scheduleForModal = {} as Schedule;
  scheduleForModalIdx: number;
  
  phoneNumber: string;

  constructor(
    private profileService: ProfileService,
    private contentService: ContentService,
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    // private tts: TextToSpeech,
    private appConfigService: AppConfig,
    private analyticsService: AnalyticsService,
    public loadData: LoadDataService
  ) { }

  ngOnInit() {
    // var msg = new SpeechSynthesisUtterance();
    // msg.text = "Argentina es el campeón del mundo!!! Papá!!";
    // msg.lang = 'es';
    
    // msg.addEventListener( "end", resp => {
    //   console.log( "termino??", resp)
    // })
    // window.speechSynthesis.speak(msg);
    this.contentService.normalizeString('áéíóúâêîôûàèìòùäëïöü ñ ,;.')
  }


  ionViewDidEnter() {
    this.phoneNumber = this.profileService.profile.phoneNumber;

    if ( this.platform.is("hybrid") ) {
      this.showBtnApp = true;
    }

    if ( this.platform.is("ios") ) {
      this.showIos = true;
    }

    this.route.params.subscribe (
      x => {
        setTimeout(() => {
          this.contentService.getContent(x.id, this.profileService.profile.id )
          .subscribe((resp: Content) => {
            console.log( resp )
            this.content = resp;

            this.loading = false;
            // this.speak();
          })  
        }, 1800);
        
    })   
  }

  ionViewWillLeave() {
    // this.tts.stop();
    this.loading = true;
  }

  isHappening(resp: any ) {

    if ( resp.dateTo ) {
      if ( moment().isBetween(moment(resp.dateFrom), moment(resp.dateTo) ) ) {
        return true
      } else {
        return false
      }
    }
    
  }

  async speak() {

    TextToSpeech.getSupportedLanguages().then( resp => console.log( resp ))
      this.playing = true;
      this.isStopped = false;

      TextToSpeech.speak({
        text: this.content.title,
        lang: 'es-AR',
      }).then( resp => {
        // setTimeout(() => {

        //   if( !this.isStopped ) {
        //     TextToSpeech.speak({
        //       text: this.content.shortDescription,
        //       lang: 'es-AR'
        //     }).then( resp => {
              setTimeout(() => {
                if( !this.isStopped ) {
                  TextToSpeech.speak({
                    text: this.content.longDescription,
                    lang: 'es-AR',
                  }).then( resp => {
                    this.playing = this.playing = false;
                  })
                }
              }, 300);
              
            // })
          // }
          
        // }, 300);
        
      });

  }

  stopSpeak() {
    this.playing = false;
    this.isStopped = true;
    TextToSpeech.stop();
  }

  openApp() {
    var option: OpenURLOptions;
    // console.log(this.platform.platforms())
    if(this.platform.is("mobileweb") || this.platform.is("desktop") ){
      option = {
        url: this.content.linkUrl
      } as OpenURLOptions
    }
    else if (this.platform.is("android")){
      console.log(this.content.androidAppUrl);
      option = {
        url: this.content.androidAppUrl //this.packageName
      } as OpenURLOptions
    }
    else if (this.platform.is("ios")){
      console.log(this.content.iosAppUrl);
      option = {
        url: this.content.iosAppUrl //this.packageName
      } as OpenURLOptions
    }
    AppLauncher.openUrl(option)
      .then( resp => {
        console.log( resp )
        if ( !resp.completed ) {
          AppLauncher.openUrl( { url: 'https://play.google.com/store/apps/details?id='+this.content.androidAppUrl} )
        }
      })
      .catch( error => console.log( error ));
  }

  async openLink() {
    await Browser.open({ url: this.content.linkUrl })
  }

  async openVideo() {
    await Browser.open({ url: this.content.videoUrl })
  }

  async openDoc() {
    await Browser.open({ url: this.content.documentUrl })
  }

  favoriteAction() {

    !this.content.favorite ? this.addFavorite() : this.removeFavorite();
    
  }

  addFavorite(){
    
    this.content.favorite = true;

    const opt = {
      "profileId": this.profileService.profile.id,
      "contentId": this.content.id
    }

    this.contentService.addFavorite( opt )
        .subscribe( resp => console.log( resp ))
  }

  removeFavorite(){
    
    this.content.favorite = false;

    const opt = {
      "profileId": this.profileService.profile.id,
      "contentId": this.content.id
    }

    this.contentService.removeFavorite( opt )
        .subscribe( resp => console.log( resp ))
  }

  subscribe(schedule: Schedule, idx: number){

    if ( this.profileService.isAuthenticated() ) {
      this.scheduleForModalIdx = idx;
      this.scheduleForModal = schedule;
      console.log(this.scheduleForModal)
      this.modal.present();
    } else {
      this.modal5.present();
    }
  }

  subscribeOk() {
    this.modal.dismiss();
    this.modal2.present();
  }

  unsubscribe(schedule: Schedule, idx: number){
    this.scheduleForModalIdx = idx;
    this.scheduleForModal = schedule;
    console.log(this.scheduleForModal)
    this.modal3.present()
  }

  unsubscribeOk() {
    this.modal3.dismiss();
    this.modal4.present();
  }

  confirmUnsubscribe() {

    const opt = {
      "profileId": this.profileService.profile.id,
      "scheduleId": this.scheduleForModal.id,
    }

    this.contentService.unSubscribe( opt )
        .subscribe( resp => {
          this.unsubscribeOk();
          this.content.schedules[this.scheduleForModalIdx].subscribe = false;
        })
  }

  confirmSubscribe() {

    const opt = {
      "profileId": this.profileService.profile.id,
      "scheduleId": this.scheduleForModal.id,
    }

    this.profileService.profile.phoneNumber = this.phoneNumber;
    console.log( this.profileService.profile)
    
    this.contentService.subscribe( opt )
        .subscribe( resp => {
          this.subscribeOk();
          this.content.schedules[this.scheduleForModalIdx].subscribe = true;
          this.profileService.setProfile(this.profileService.profile);
        })
  }

  meInteresa( schedule: Schedule, idx: number ) {

    if ( this.profileService.isAuthenticated() ) {
      this.scheduleForModalIdx = idx;
      this.scheduleForModal = schedule;

      const opt = {
        "profileId": this.profileService.profile.id,
        "scheduleId": schedule.id,
      }

      this.contentService.interest( opt )
          .subscribe( resp => {
            this.content.schedules[this.scheduleForModalIdx].interest = true;
          })
    } else {
      this.modal5.present()
    }
  }

  closeModals(dialog:string) {
    if( dialog === "confirm") {
      this.modal.dismiss();
      this.modal5.dismiss();
    } else if ( dialog === 'ok' ) {
      this.modal2.dismiss();
    } else if ( dialog === 'confirm-unsubscribe' ) {
      this.modal3.dismiss();
    } else if ( dialog === 'confirm-share' ) {
      this.modalShare.dismiss();
    } else {
      this.modal4.dismiss();
    }
  }

  signIn() {
    this.modal5.dismiss();
    this.profileService.signIn(this.content.id);
    this.router.navigateByUrl('navigator/content/00');
  }

  async share() {
    await Share.share({
      title: this.content.title,
      text: this.content.title,
      url: 'https://'+this.appConfigService.getConfig( 'app_url' )+'/navigator/content/'+this.content.id,
      // dialogTitle: 'Share with buddies',
    }).then( success => {
      this.contentService.shareContent(this.profileService.profile.id, this.content.id )
          .subscribe( resp => {
            console.log( 'le mande el share al BE');
            this.analyticsService.logEvent( 'share', { content_id: this.content.id } );
          });
    });
  }

  async showModalShare() {
    await this.contentService.shareContent(this.profileService.profile.id, this.content.id )
          .subscribe( resp => console.log( 'le mande el share al BE') );
    await this.modalShare.present();
    this.analyticsService.logEvent( 'share', { content_id: this.content.id } );
  }

  getTenerEnCuenta() {
    if (
      this.content.free != null ||
      this.content.limitedVacancy != null ||
      this.content.duringHollidays != null ||
      this.content.subscriptionRequired != null ||
      this.content.suspendedDueToRain != null ||
      this.content.neededMaterials != null ||
      this.content.permanence != null ||
      this.content.physicallyFit != null ||
      this.content.priorKnowledge != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  getDateInfo( fromDate, toDate) {
    const from = moment(fromDate);
    const to = moment(toDate);

    const fromDay = moment(fromDate).format('YYYY/MM/DD');
    const toDay = moment(toDate).format('YYYY/MM/DD');

    if ( fromDay == toDay ) {
      return from.format( 'dddd D MMMM YYYY, HH:mm') + 'Hs hasta ' + to.format( 'HH:mm') + 'Hs'
    }

    if ( from !== to ) {
      return from.format( 'dddd D MMMM YYYY, HH:mm') + 'Hs hasta ' + to.format( 'dddd D MMMM YYYY, HH:mm') + 'Hs'
    }
  }

  goToMap( place: Place) {

    const filters = {
        contentId : place.id
    }
    this.router.navigate(['/navigator/map-result', place.name, 'one-place', filters])
  }

  

  goToTag(id:string, tag: string) {
    const tagName = this.contentService.normalizeString( tag );
    this.loadData.selectedTag = tag;
    localStorage.setItem( 'selectedTag', tag );
    this.router.navigate(['/navigator/results/', id, tagName])
  }
}
